import { connect } from 'react-redux';
import {PurchaseData, datosCompra, eventoSeleccionado} from '../../../types/types';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import {Col,Button, Row, Modal, ModalHeader, ModalBody} from 'reactstrap';
import CompraEventoSingular from '../compra/CompraEventoSingular';
import CompraEventoPlural from '../compra/CompraEventoPlural';
import CompraEventoSeat from '../compra/CompraEventoSeat';
import '../../sass/evento_seleccionado/paso_dos.scss'
import TituloEvento from './TituloEvento';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';

type configObjectDatosComprados = {
    eventsReducer: {
        datosCompraPasoDos: PurchaseData;
        detalleCompra:datosCompra;
        eventoSeleccionado: eventoSeleccionado
    }
  }

const PasoDosEvento = ({datosCompraPasoDos, detalleCompra, eventoSeleccionado}:{datosCompraPasoDos:PurchaseData, detalleCompra:datosCompra, eventoSeleccionado:eventoSeleccionado}) => {
    const navigate = useNavigate();
    const [modalPrecios, setModalPrecios] = useState(false);
    useEffect(() => {
        window.onpageshow = (event) => {
            if (event.persisted) {
                console.log('Página restaurada desde el caché, recargando...');
                window.location.reload();
            }
          };
      }, []);

    const toggleModalPrecios = () => {
        setModalPrecios(!modalPrecios);
    }

    return (
        <div className='compra-paso-dos'>
          {datosCompraPasoDos && <>
            {detalleCompra && <TituloEvento paso={2}/>}
                <Row>
                    <Col className='d-flex justify-content-between mb-2'>
                        <h4 className='add-places-text subtitle'>Agrega Tus Lugares</h4>
                        {datosCompraPasoDos.purchaseType !== 'SINGULAR' && <Button className='btn-sm' style={{height: "fit-content"}} onClick={toggleModalPrecios}>Ver Precios</Button>}
                    </Col>
                </Row>
                <Modal className='modal-precios' isOpen={modalPrecios} toggle={toggleModalPrecios} centered={true}>
                    <ModalHeader toggle={toggleModalPrecios}>PRECIOS</ModalHeader>
                    <ModalBody>
                        <div dangerouslySetInnerHTML={{ __html: eventoSeleccionado.infoPrices.replace(/\n/g, '<br />') }} />
                    </ModalBody>
                </Modal>
                {datosCompraPasoDos.purchaseType === 'SINGULAR' && <CompraEventoSingular />}
                {datosCompraPasoDos.purchaseType === 'PLURAL' && <CompraEventoPlural />}
                {datosCompraPasoDos.purchaseType === 'SEAT' && <CompraEventoSeat />}
                <Col className='d-flex justify-content-between steps-buttons flex-column'>
                    {detalleCompra &&
                        <Button className='w-100 siguiente-paso'
                        onClick={()=>{
                            const hash = window.location.pathname.split("/")[2];
                            navigate(`/evento/${hash}/step/3`)
                        }}
                        disabled={detalleCompra.ticketsQuantity === 0}> Siguiente Paso <ArrowForwardIosIcon /></Button>}
                        <Button className='w-100 back_2' onClick={()=>{window.history.go(-1)}}><ArrowBackIosIcon /> Paso Anterior</Button>
                </Col>
          </>}
        </div>
    );
};

const mapStateToProps = (state: configObjectDatosComprados) => {
    return {
        datosCompraPasoDos: state.eventsReducer.datosCompraPasoDos,
        detalleCompra: state.eventsReducer.detalleCompra,
        eventoSeleccionado: state.eventsReducer.eventoSeleccionado
    }
}
export default connect(
    mapStateToProps,
   null
)(PasoDosEvento);

